import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostUsers_idResend_verification_email = z.any()
export type TagsPostUsers_idResend_verification_email = z.infer<typeof tagsPostUsers_idResend_verification_email>

export const descriptionPostUsers_idResend_verification_email = z.any()
export type DescriptionPostUsers_idResend_verification_email = z.infer<typeof descriptionPostUsers_idResend_verification_email>

export const paramsPostUsers_idResend_verification_email = z.object({ "id": z.string().uuid() })
export type ParamsPostUsers_idResend_verification_email = z.infer<typeof paramsPostUsers_idResend_verification_email>

export const responsePostUsers_idResend_verification_email = z.any()
export type ResponsePostUsers_idResend_verification_email = z.infer<typeof responsePostUsers_idResend_verification_email>

interface IPostUsers_idResend_verification_email extends BaseMethodType {
  tags: TagsPostUsers_idResend_verification_email,
  description: DescriptionPostUsers_idResend_verification_email,
  params: ParamsPostUsers_idResend_verification_email,
  response: ResponsePostUsers_idResend_verification_email
}
export const URL = '/users/:id/resend-verification-email'
export const validation = {
  post: {
    tags: tagsPostUsers_idResend_verification_email,
    description: descriptionPostUsers_idResend_verification_email,
    params: paramsPostUsers_idResend_verification_email,
    response: responsePostUsers_idResend_verification_email
  }
}
export interface Users_idResend_verification_email extends BaseRouteType {
  post: IPostUsers_idResend_verification_email
}